import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import {
    GET_BRANDING_OPPORTUNITY_APPROVAL_DETAILS_ACTION_TYPE, GET_BRANDING_OPPORTUNITY_APPROVAL_LIST_ACTION_TYPE, GET_BRANDING_OPPORTUNITY_APPROVAL_EXPORT_DATA_ACTION_TYPE, UPDATE_BRANDING_OPPORTUNITY_APPROVAL__ACTION_TYPE,
    getBrandingOpportunityApprovalDetailsUrl, getBrandingOpportunityApprovalListUrl, getBrandingOpportunityExportDataUrl, updateBrandingOpportunityApprovalUrl, headers
} from "../../../../utils/constants";

export const getBrandingOpportunityApprovalDetails_action = (companyName, status, exhibitorTypeId) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            CompanyName: companyName,
            Status: status,
            ExhibitorTypeID: exhibitorTypeId,
        }
        console.log("getVisitorVisaInvitation_action Action------->", params)

        const res = await axiosGet(getBrandingOpportunityApprovalDetailsUrl, params, headers)

        dispatch({
            type: GET_BRANDING_OPPORTUNITY_APPROVAL_DETAILS_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getBrandingOpportunityApprovalList_action = (companyname) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            CompanyName: companyname,
            ExhRegistrationID: sessionStorage.getItem('ExhRegistrationIDSS'),

        }
        console.log("getVisitorVisaApplication_action Action------->", params)

        const res = await axiosGet(getBrandingOpportunityApprovalListUrl, params, headers)

        dispatch({
            type: GET_BRANDING_OPPORTUNITY_APPROVAL_LIST_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getBrandingOpportunityExportData_action = (status) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            Status: status,
        }
        console.log("getVisitorVisaisaApplicationExportData_action Action------->", params)

        const res = await axiosGet(getBrandingOpportunityExportDataUrl, params, headers)

        dispatch({
            type: GET_BRANDING_OPPORTUNITY_APPROVAL_EXPORT_DATA_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateBrandingOpportunityApproval_action = (isApproved, list) => async (dispatch) => {
    try {
        const mapData = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            Is_Approved: isApproved,
            approvalList: list
        }
        console.log("updateVisitorVisaApproval_action Action------->", mapData)

        const res = await axiosPost(updateBrandingOpportunityApprovalUrl, mapData, headers)

        dispatch({
            type: UPDATE_BRANDING_OPPORTUNITY_APPROVAL__ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

